import AnswerWinReportServices from '@/services-ts/Report/AnswerWinReportServices'
import DashboardServices from '@/services-ts/Report/DashboardServices'
import PointReportServices from '@/services-ts/Report/PointReportServices'
import ReportServices from '@/services-ts/Report/ReportServices'
import SurveyReportServices from '@/services-ts/Report/SurveyReportServices'
import TierReportServices from '@/services-ts/Report/TierReportServices'
import WordGameReportServices from '@/services-ts/Report/WordGameReportServices'

const ReportAPI = (apiReport: string) => {
  return {
    ReportServices: new ReportServices(apiReport),
    TierReportServices: new TierReportServices(apiReport),
    AnswerWinReportServices: new AnswerWinReportServices(apiReport),
    PointReportServices: new PointReportServices(apiReport),
    SurveyReportServices: new SurveyReportServices(apiReport),
    DashboardServices: new DashboardServices(apiReport),
    WordGameReportServices: new WordGameReportServices(apiReport),
  }
}

export default ReportAPI
